// AI Automation Action Types
export const CREATE_AI_AUTOMATION_WORKFLOW = "CREATE_AI_AUTOMATION_WORKFLOW";
export const CREATE_AI_AUTOMATION_WORKFLOW_SUCCESS =
  "CREATE_AI_AUTOMATION_WORKFLOW_SUCCESS";
export const CREATE_AI_AUTOMATION_WORKFLOW_FAILURE =
  "CREATE_AI_AUTOMATION_WORKFLOW_FAILURE";

export const UPDATE_AI_AUTOMATION_WORKFLOW = "UPDATE_AI_AUTOMATION_WORKFLOW";
export const UPDATE_AI_AUTOMATION_WORKFLOW_SUCCESS =
  "UPDATE_AI_AUTOMATION_WORKFLOW_SUCCESS";
export const UPDATE_AI_AUTOMATION_WORKFLOW_FAILURE =
  "UPDATE_AI_AUTOMATION_WORKFLOW_FAILURE";

export const DELETE_AI_AUTOMATION_WORKFLOW = "DELETE_AI_AUTOMATION_WORKFLOW";
export const DELETE_AI_AUTOMATION_WORKFLOW_SUCCESS =
  "DELETE_AI_AUTOMATION_WORKFLOW_SUCCESS";
export const DELETE_AI_AUTOMATION_WORKFLOW_FAILURE =
  "DELETE_AI_AUTOMATION_WORKFLOW_FAILURE";

export const GET_AI_AUTOMATION_WORKFLOW = "GET_AI_AUTOMATION_WORKFLOW";
export const GET_AI_AUTOMATION_WORKFLOW_SUCCESS =
  "GET_AI_AUTOMATION_WORKFLOW_SUCCESS";
export const GET_AI_AUTOMATION_WORKFLOW_FAILURE =
  "GET_AI_AUTOMATION_WORKFLOW_FAILURE";

export const LIST_AI_AUTOMATION_WORKFLOWS = "LIST_AI_AUTOMATION_WORKFLOWS";
export const LIST_AI_AUTOMATION_WORKFLOWS_SUCCESS =
  "LIST_AI_AUTOMATION_WORKFLOWS_SUCCESS";
export const LIST_AI_AUTOMATION_WORKFLOWS_FAILURE =
  "LIST_AI_AUTOMATION_WORKFLOWS_FAILURE";

export const EXECUTE_AI_AUTOMATION_WORKFLOW = "EXECUTE_AI_AUTOMATION_WORKFLOW";
export const EXECUTE_AI_AUTOMATION_WORKFLOW_SUCCESS =
  "EXECUTE_AI_AUTOMATION_WORKFLOW_SUCCESS";
export const EXECUTE_AI_AUTOMATION_WORKFLOW_FAILURE =
  "EXECUTE_AI_AUTOMATION_WORKFLOW_FAILURE";

// AI Automation Action Creators

// Create a new AI automation workflow
export const createAiAutomationWorkflow = (workflowInput) => ({
  type: CREATE_AI_AUTOMATION_WORKFLOW,
  payload: workflowInput,
});

// Successful AI automation workflow creation
export const createAiAutomationWorkflowSuccess = (response) => ({
  type: CREATE_AI_AUTOMATION_WORKFLOW_SUCCESS,
  payload: response,
});

// Failed AI automation workflow creation
export const createAiAutomationWorkflowFailure = (error) => ({
  type: CREATE_AI_AUTOMATION_WORKFLOW_FAILURE,
  payload: error,
});

// Update an AI automation workflow
export const updateAiAutomationWorkflow = (workflowInput) => ({
  type: UPDATE_AI_AUTOMATION_WORKFLOW,
  payload: workflowInput,
});

// Successful AI automation workflow update
export const updateAiAutomationWorkflowSuccess = (response) => ({
  type: UPDATE_AI_AUTOMATION_WORKFLOW_SUCCESS,
  payload: response,
});

// Failed AI automation workflow update
export const updateAiAutomationWorkflowFailure = (error) => ({
  type: UPDATE_AI_AUTOMATION_WORKFLOW_FAILURE,
  payload: error,
});

// Delete an AI automation workflow
export const deleteAiAutomationWorkflow = (workflowId, tenantId) => ({
  type: DELETE_AI_AUTOMATION_WORKFLOW,
  payload: { workflowId, tenantId },
});

// Successful AI automation workflow deletion
export const deleteAiAutomationWorkflowSuccess = (response) => ({
  type: DELETE_AI_AUTOMATION_WORKFLOW_SUCCESS,
  payload: response,
});

// Failed AI automation workflow deletion
export const deleteAiAutomationWorkflowFailure = (error) => ({
  type: DELETE_AI_AUTOMATION_WORKFLOW_FAILURE,
  payload: error,
});

// Get a single AI automation workflow
export const getAiAutomationWorkflow = (workflowId, tenantId) => ({
  type: GET_AI_AUTOMATION_WORKFLOW,
  payload: { workflowId, tenantId },
});

// Successful AI automation workflow retrieval
export const getAiAutomationWorkflowSuccess = (response) => ({
  type: GET_AI_AUTOMATION_WORKFLOW_SUCCESS,
  payload: response,
});

// Failed AI automation workflow retrieval
export const getAiAutomationWorkflowFailure = (error) => ({
  type: GET_AI_AUTOMATION_WORKFLOW_FAILURE,
  payload: error,
});

// List AI automation workflows
export const listAiAutomationWorkflows = (tenantId, status, limit) => ({
  type: LIST_AI_AUTOMATION_WORKFLOWS,
  payload: { tenantId, status, limit },
});

// Successful AI automation workflows listing
export const listAiAutomationWorkflowsSuccess = (response) => ({
  type: LIST_AI_AUTOMATION_WORKFLOWS_SUCCESS,
  payload: response,
});

// Failed AI automation workflows listing
export const listAiAutomationWorkflowsFailure = (error) => ({
  type: LIST_AI_AUTOMATION_WORKFLOWS_FAILURE,
  payload: error,
});

// Execute an AI automation workflow
export const executeAiAutomationWorkflow = (workflowInput) => ({
  type: EXECUTE_AI_AUTOMATION_WORKFLOW,
  payload: workflowInput,
});

// Successful AI automation workflow execution
export const executeAiAutomationWorkflowSuccess = (response) => ({
  type: EXECUTE_AI_AUTOMATION_WORKFLOW_SUCCESS,
  payload: response,
});

// Failed AI automation workflow execution
export const executeAiAutomationWorkflowFailure = (error) => ({
  type: EXECUTE_AI_AUTOMATION_WORKFLOW_FAILURE,
  payload: error,
});
